import { generalAssemblyInvitations } from "@modules/general-assembly/data";
import { GeneralAssemblyInvitation } from "@modules/general-assembly/types";
import { getCurrentLocaleCode, trans } from "@mongez/localization";
import { ChevronRightIcon } from "lucide-react";

export function InvitationTab() {
  return (
    <div className="flex animate-fade flex-col gap-6 rounded-3xl border border-[#E0E0E0] p-4 md:gap-8 md:p-8">
      <p className="font-semibold text-marine">{trans("invitations")}</p>
      <div className="flex flex-col gap-6">
        {generalAssemblyInvitations.map((invitation) => (
          <InvitationItem key={invitation.id} invitation={invitation} />
        ))}
      </div>
    </div>
  );
}

type InvitationItemProps = {
  invitation: GeneralAssemblyInvitation;
};

function InvitationItem({ invitation }: InvitationItemProps) {
  const locale = getCurrentLocaleCode();
  const localizedUrl = invitation.url(locale);

  return (
    <div className="group flex cursor-pointer flex-col gap-4 rounded-3xl border border-[#E0E0E0] bg-white p-4 shadow-sm transition-colors duration-300 hover:bg-gray-100">
      <a
        target="_blank"
        href={localizedUrl}
        className="flex items-center justify-between gap-2 font-semibold text-marine"
      >
        {trans(invitation.title)}
        <ChevronRightIcon className="h-4 w-4 rtl:rotate-180" />
      </a>
    </div>
  );
}
